import BlankLayout from "layout/BlankLayout";

const ThankYou = () => {
  return (
    <BlankLayout>
      <>
        <div className="section"></div>
        <div className="section">
          <div className="container"></div>
          <div className="container">
            <div className="social-media-heading">
              <h3 className="heading-2">
                Thank you for completing the study. You can successfully
                reviewed 3 sets of recommendations and offered feedback. <br />
                <br />
                We appreciate your time and insights.{" "}
              </h3>
            </div>
          </div>
        </div>
      </>
    </BlankLayout>
  );
};

export default ThankYou;
